<template>
    <span class="service-worker-plh"></span>
</template>
<script lang="ts">
    export default defineComponent({
        setup() {
            const isSubscribed = ref(false);
            const config = useRuntimeConfig();

            const initialiseServiceWorker = () => {
                if ("serviceWorker" in navigator) {
                    navigator.serviceWorker
                        .register("/sw.js", { scope: "/" })
                        .then(handleSWRegistration);
                } else {
                    console.log(
                        "[initialiseServiceWorker] Service workers are not supported in this browser."
                    );
                }
            }

            const handleSWRegistration = (reg) => {
                if (reg.installing) {
                    console.log("Service worker installing");
                } else if (reg.waiting) {
                    console.log("Service worker installed");
                } else if (reg.active) {
                    console.log("Service worker active");
                }

                initialiseState(reg);
            }

            const urlB64ToUint8Array = (base64String) => {
                const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
                const base64 = (base64String + padding)
                    .replace(/-/g, "+")
                    .replace(/_/g, "/");

                const rawData = window.atob(base64);
                const outputArray = new Uint8Array(rawData.length);

                for (let i = 0; i < rawData.length; ++i) {
                    outputArray[i] = rawData.charCodeAt(i);
                }
                return outputArray;
            }

            const base64Encode = (arrayBuffer) => {
                return btoa(String.fromCharCode.apply(null, new Uint8Array(arrayBuffer)));
            }

            const initialiseState = (reg) => {
                // Are Notifications supported in the service worker?
                if (!reg.showNotification) {
                    console.log(
                        "[initialiseState] Notifications aren't supported on service workers."
                    );
                    return;
                }

                // Check if push messaging is supported
                if (!("PushManager" in window)) {
                    console.log("[initialiseState] Push messaging isn't supported.");
                    return;
                }

                // We need the service worker registration to check for a subscription
                navigator.serviceWorker.ready.then((reg) => {
                    // Do we already have a push message subscription?
                    reg.pushManager
                        .getSubscription()
                        .then((subscription) => {
                            isSubscribed.value = subscription;
                            if (isSubscribed.value) {
                                console.log("User is already subscribed to push notifications");
                                // this.unsubscribe();
                            } else {
                                console.log("User is not yet subscribed to push notifications");
                            }
                        })
                        .catch((err) => {
                            console.log(
                                "[req.pushManager.getSubscription] Unable to get subscription details.",
                                err
                            );
                        });
                });
            }

            const subscribe = () => {
                navigator.serviceWorker.ready.then((reg) => {
                    // Setting the public key of our VAPID key pair.
                    const applicationServerKey = urlB64ToUint8Array(
                        config.public.webPushServerPublicKey
                    );

                    const subscribeParams = {
                        userVisibleOnly: true,
                        applicationServerKey,
                    };

                    reg.pushManager
                        .subscribe(subscribeParams)
                        .then((subscription) => {
                            isSubscribed.value = true;

                            const p256dh = base64Encode(subscription.getKey("p256dh"));
                            const auth = base64Encode(subscription.getKey("auth"));

                            useApiClient().userWebTokenSave({
                                Token: {
                                    pushEndPoint: subscription.endpoint,
                                    pushP256DH: p256dh,
                                    pushAuth: auth,
                                }
                            });
                        })
                        .catch((e) => {
                            console.log("[subscribe] Unable to subscribe to push", e);
                            this.unsubscribe(); // Đoạn này nháp lúc test khi đổi public key
                        });
                });
            }

            const unsubscribe = () => {
                navigator.serviceWorker.ready
                    .then((registration) => {
                        return registration.pushManager.getSubscription();
                    })
                    .then((subscription) => {
                        return subscription
                            .unsubscribe()
                            .then(() => {
                                console.log("Unsubscribed", subscription.endpoint);
                                useApiClient().userWebTokenDelete({
                                    ...subscription,
                                });
                            })
                            .catch((e) => {
                                console.log("[subscribe] Unable to unsubscribe push", e);
                            });
                    });
            }

            onMounted(() => {
                console.log(config)
                if (!config.public.webPushServerPublicKey) {
                    console.error("WebPushServerPublicKey is not set in the runtime config");
                    return;
                }
                Notification.requestPermission().then((status) => {
                    if (status === "denied") {
                        console.log(
                            "[Notification.requestPermission] Browser denied permissions to notification api."
                        );
                    } else if (status === "granted") {
                        console.log(
                            "[Notification.requestPermission] Initializing service worker."
                        );
                        initialiseServiceWorker();
                    }
                });
                subscribe();
            });

            return {

            };
        }
    });
</script>
